
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'CaretakerOrdersHeader'
})
export default class extends Vue {
}
